import React, { Component } from 'react';

import { IonContent, IonHeader, IonTitle, IonToolbar, IonButtons, IonBackButton } from '@ionic/react';

// import HeaderButtons from '../components/HeaderButtons';
import OptionService from '../services/option';
import ChatBot from '../components/Home/ChatBot';

export default class FAQPage extends Component {
  constructor(props) {
    super(props);
    this.optionChatbot = null;
    this.state = {
      privacy: '',
    };
  }
  componentDidMount() {
    OptionService.allClean()
      .then((data) => {
        if (data.data.data.chatbot) {
          this.optionChatbot = data.data.data.chatbot;
        } else {
          this.optionChatbot = 0;
        }
      })
      .catch((error) => {
        console.error('Errore nel recupero delle opzioni:', error);
      });
  }
  async ionViewWillEnter() {
    try {
      let [
        {
          value: {
            data: { value: faq },
          },
        },
      ] = await Promise.allSettled([OptionService.get('faq')]);
      this.setState({ faq });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" />
            </IonButtons>

            {/* <HeaderButtons {...this.props} />   */}

            <IonTitle>Domande frequenti</IonTitle>
          </IonToolbar>
        </IonHeader>
        {this.optionChatbot === '1' && (
          <IonContent className="ion-margin ion-padding">
            <ChatBot />
            <div dangerouslySetInnerHTML={{ __html: this.state.faq }} />
          </IonContent>
        )}
      </>
    );
  }
}
